import React from 'react';
import {
  SearchOutlined
} from '@ant-design/icons';
import './index.css';

class Search extends React.Component {
  constructor(props) {
    super(props);
  }
  render () {
    return (
      <div className="search_bg" style={{ borderRight: this.props.borderRight ? this.props.borderRight : "" }}>
        <div className="search">
          <SearchOutlined style={{
            color: "var(--light_text_color)",
            marginLeft: "10px"
          }} />
          <input className="input" placeholder="搜索" onInput={this.onInput.bind(this)} onKeyUp={this.onKeyUp.bind(this)}></input>
        </div>
      </div>
    );
  }
  onKeyUp (e) {
    if (e.keyCode == 13) {
      if (this.props.endSearch) {
        this.props.endSearch(e.target.value);
      }
    }
  }
  onInput(e){
    if(this.props.onInput){
      this.props.onInput(e.target.value);
    }
  }
}
export default Search;